export const doctorSpecialist=[

       "Allergists",
       "Anesthesiologists",
       "Cardiologists",
       "Dermatologists",
       "Endocrinologists",
       "Emergency Medicine Specialists",
       "Gastroenterologists",
       "Hematologists",
       "Nephrologists",
       "Neurologists",
       "Oncologists",
       "Pathologists"
]